var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "chemsnap-modal chemtracker-module"
  }, [_c('header', {
    staticClass: "chemsnap-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "header-close"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "aria-label": "close modal"
    },
    on: {
      "&click": function ($event) {
        return _vm.$emit('close-modal');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.closeIconSrc,
      "alt": "close button"
    }
  })])])]), _vm._v(" "), _vm.isBusy ? _c('div', {
    staticClass: "uploading-screen"
  }, [_c('raft-busy', {
    attrs: {
      "busy-text": _vm.busyText,
      "is-raft-styling": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chemsnap-button"
  }, [_c('v-button', {
    staticClass: "ghost destructive small",
    attrs: {
      "aria-label": "cancel upload"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")])], 1)], 1) : _c('div', {
    staticClass: "sample-image-screen"
  }, [_c('p', [_vm._v("\n      Take or upload a photo of your container with the label prominently\n      shown.\n    ")]), _vm._v(" "), _c('h2', [_vm._v("Example")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": _vm.exampleSrc,
      "alt": "example container with label shown"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "chemsnap-button"
  }, [_c('v-button', {
    staticClass: "primary small",
    attrs: {
      "aria-label": "upload"
    },
    on: {
      "click": _vm.onUploadFile
    }
  }, [_vm._v("Upload")]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "accept": "image/*",
      "hidden": ""
    },
    on: {
      "change": _vm.onFilePicked
    }
  })], 1)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "header-title"
  }, [_c('h1', [_vm._v("ChemSnap AI")]), _vm._v(" "), _c('div', {
    staticClass: "beta-tag"
  }, [_c('p', [_vm._v("Beta")])])]);

}]

export { render, staticRenderFns }